module.exports = __webpack_public_path__ + "img/1ANV_logo_color.28d94244.png";